/**
 * Grounded certification.
 *
 * Single source of truth for the certification threshold. Never hardcode the
 * number anywhere else — import CERTIFIED_SCORE_THRESHOLD or isCertified().
 */

export const CERTIFIED_SCORE_THRESHOLD = 80;

export function isCertified(score: number | null | undefined): boolean {
  if (score == null) return false;
  return score >= CERTIFIED_SCORE_THRESHOLD;
}

export const CERTIFIED_LABEL = "Grounded certified";
